import styles from './EmptyLayout.module.css'

const EmptyLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className={`${styles['container']} ver-flex ver-items-center`}>
    {children}
  </div>
)

export default EmptyLayout
